
import React, {useContext} from "react";
import classnames from "classnames";
// reactstrap components
import {
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Row,
    Col,
    Label, CardHeader,Card, CardBody,FormGroup
} from "reactstrap";
import { RegistrationContext } from "../../../context/RegistrationContext";

const Step2 = React.forwardRef((props, ref) => {
    // eslint-disable-next-line
    const [registrationState, setRegistrationState] = useContext(RegistrationContext);
    const [fullname, setfullname] = React.useState("");
    const [fullnameState, setfullnameState] = React.useState("");
    const [fullnameFocus, setfullnameFocus] = React.useState("");
    // eslint-disable-next-line
    const [email, setemail] = React.useState("");
    const [emailState, setemailState] = React.useState("");
    const [emailFocus, setemailFocus] = React.useState("");
    // eslint-disable-next-line
    const [phone, setphone] = React.useState("");
    const [phoneFocus, setphoneFocus] = React.useState("");
    const [phoneState, setphoneState] = React.useState("");
    // eslint-disable-next-line
    const [dob, setdob] = React.useState("");
    const [dobFocus, setdobFocus] = React.useState("");
    const [dobState, setdobState] = React.useState("");
    // eslint-disable-next-line
    const [gender, setgender] = React.useState("Male");
    const [genderFocus, setgenderFocus] = React.useState("");
    const [genderState, setgenderState] = React.useState("has-success");
    // eslint-disable-next-line
    const [questions, setquestions] = React.useState("");
    const [questionsFocus, setquestionsFocus] = React.useState("");
    const [questionsState, setquestionsState] = React.useState("");


    const stateFunctions = {
        setphoneState: (value) => setphoneState(value),
        setphone: (value) => setphone(value),
        setemailState: (value) => setemailState(value),
        setemail: (value) => setemail(value),
        setfullnameState: (value) => setfullnameState(value),
        setfullname: (value) => setfullname(value),
        setgenderState: (value) => setgenderState(value),
        setgender: (value) => setgender(value),
        setdobState: (value) => setdobState(value),
        setdob: (value) => setdob(value),
        setquestionsState: (value) => setquestionsState(value),
        setquestions: (value) => setquestions(value)
    };
    // function that returns true if value is email, false otherwise
    const verifyEmail = (value) => {
        var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (emailRex.test(value)) {
            return true;
        }
        return false;
    };
    // function that verifies if a string has a given length or not
    const verifyLength = (value, length) => {
        if (value.length >= length) {
            return true;
        }
        return false;
    };
    // function that verifies if value contains only numbers
    const verifyNumber = (value) => {
        var numberRex = new RegExp("^[0-9]+$");
        if (numberRex.test(value)) {
            return true;
        }
        return false;

    };
    // function that verifies if a string has a given length or not
    const verifyPhone = (value, length) => {
        return value.length === length;
    };
    // function that verifies if a string has a given length or not
    const verifyDate = (value, length) => {
        return value.length === length;
    };
    //Normalize date input to MM/DD/YYYY
    const normalizeDateInput = (value, previousValue) => {
        //debugger;
        if (!value) return value;
        const currentValue = value.replace(/[^\d]/g, '');
        const cvLength = currentValue.length;

        if (!previousValue || value.length > previousValue.length) {
            if (cvLength < 3) return currentValue;
            if (cvLength < 6) return `${currentValue.slice(0, 2)}/${currentValue.slice(2)}`;
            return `${currentValue.slice(0, 2)}/${currentValue.slice(2, 4)}/${currentValue.slice(4, 8)}`;
        }
    };
    //Used to format the phone number corrrectly
    const normalizePhoneInput = (value, previousValue) => {
        //debugger;
        if (!value) return value;
        const currentValue = value.replace(/[^\d]/g, '');
        const cvLength = currentValue.length;

        if (!previousValue || value.length > previousValue.length) {
            if (cvLength < 4) return currentValue;
            if (cvLength < 7) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
            return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
        }
    };

    const change = (event, stateName, type, stateNameEqualTo, maxValue) => {
        switch (type) {
            case "email":
                if (verifyEmail(event.target.value)) {
                    stateFunctions["set" + stateName + "State"]("has-success");
                } else {
                    stateFunctions["set" + stateName + "State"]("has-danger");
                }
                stateFunctions["set" + stateName](event.target.value);
                break;
            case "length":
                if (verifyLength(event.target.value, stateNameEqualTo)) {
                    stateFunctions["set" + stateName + "State"]("has-success");
                } else {
                    stateFunctions["set" + stateName + "State"]("has-danger");
                }
                stateFunctions["set" + stateName](event.target.value);
                break;
            case "number":
                if (verifyNumber(event.target.value, stateNameEqualTo)) {
                    stateFunctions["set" + stateName + "State"]("has-success");
                } else {
                    stateFunctions["set" + stateName + "State"]("has-danger");
                }
                stateFunctions["set" + stateName](event.target.value);
                break;
            case "phone":
                //Lets first normalize the number to (###) ### - ####
                setphone(prevState => normalizePhoneInput(event.target.value, prevState));
                //var formattedPhone = normalizeInput(event.target.value, phone);
                //debugger;
                if (verifyPhone(event.target.value, 14)) {
                    stateFunctions["set" + stateName + "State"]("has-success");
                } else {
                    stateFunctions["set" + stateName + "State"]("has-danger");
                }
                break;
            case "date":
                //verify date mm/dd/yyyy
                //Lets first normalize the number to (###) ### - ####
                setdob(prevState => normalizeDateInput(event.target.value, prevState));
                if (verifyDate(event.target.value, 10)) {
                    stateFunctions["set" + stateName + "State"]("has-success");
                } else {
                    stateFunctions["set" + stateName + "State"]("has-danger");
                }
                break;
            case "questions":
                const updatedQuestions = [...registrationState.EventIncludedQuestions];
                updatedQuestions[event.target.dataset.idx].Value = event.target.value;
                setRegistrationState(registrationState => ({...registrationState, EventIncludedQuestions: updatedQuestions}));

                // Validate using the UPDATED questions array (not the old state)
                if (updatedQuestions.length !== 0) {
                    const allAnswered = updatedQuestions.every(q => {
                        // For checkboxes, check if they're checked
                        const qType = (q.Type || "String").trim();
                        if (qType === "Checkbox") {
                            return q.Value === "true" || q.Value === true;
                        }
                        // For all other types, check if value is not empty
                        return q.Value && q.Value.trim() !== "";
                    });

                    if(allAnswered) {
                        stateFunctions["set" + stateName + "State"]("has-success");
                    } else {
                        stateFunctions["set" + stateName + "State"]("has-danger");
                    }
                }
                break;
            default:
                break;
        }

    };
    /*eslint-disable-next-line*/
    const isValidated = () => {
        let validNameEmail = true;
        let validPhone = true;
        let validDOB = true;
        let validGender = true;
        let validQuestions = true;
        if(registrationState.EventRequireNameEmail){
            if (fullnameState === "has-success" && emailState === "has-success") {
                //Lets save the field values from the local state to the registration context
                setRegistrationState(registrationState => ({...registrationState, Name: fullname }));
                setRegistrationState(registrationState => ({...registrationState, Email: email }));
                validNameEmail = true;
            }
            else{
                if(fullnameState !== "has-success")
                    setfullnameState("has-danger");
                if (emailState !== "has-success")
                    setemailState("has-danger");
                validNameEmail = false;
            }
        }
        if(registrationState.EventRequirePhone){
            if (phoneState === "has-success") {
                //Lets save the field values from the local state to the registration context
                setRegistrationState(registrationState => ({...registrationState, Phone: phone}));
                validPhone = true;
            }
            else{
                if(phoneState !== "has-success")
                    setphoneState("has-danger");
                validPhone = false;
            }
        }
        if(registrationState.EventRequireDOB){
            if (dobState === "has-success") {
                //Lets save the field values from the local state to the registration context
                setRegistrationState(registrationState => ({...registrationState, DOB: dob}));
                validDOB = true;
            }
            else{
                if(dobState !== "has-success")
                    setdobState("has-danger");
                validDOB = false;
            }
        }
        if(registrationState.EventRequireGender){
            if (genderState === "has-success") {
                //Lets save the field values from the local state to the registration context
                setRegistrationState(registrationState => ({...registrationState, Gender: gender}));
                validGender = true;
            }
            else{
                if(genderState !== "has-success")
                    setgenderState("has-danger");
                validGender = false;
            }
        }
        if (registrationState.EventIncludedQuestions.length !== 0) {
            if (questionsState === "has-success") {
                //Lets save the field values from the local state to the registration context
                validQuestions = true;
            }
            else{
                if(questionsState !== "has-success")
                    setquestionsState("has-danger");
                validQuestions= false;
            }
        }
        return(validNameEmail && validPhone && validDOB && validGender && validQuestions);
    };
    React.useImperativeHandle(ref, () => ({
        isValidated: () => {
            return isValidated();
        },
    }));
  return (
      <>
              <Card>
                  <CardHeader>Your Information:</CardHeader>
                  <CardBody>
                      {(registrationState.EventRequireNameEmail) ? (
                      <Row>
                          <Col md={5} mdOffset={1}>
                              <FormGroup className={`has-label ${fullnameState}`}>
                                  <label>Full Name *</label>
                                  <Input
                                      name="fullname"
                                      type="text"
                                      onChange={(e) => change(e, "fullname", "length",1)}
                                  />
                                  {fullnameState === "has-danger" ? (
                                      <label className="error">
                                          Please enter your full name.
                                      </label>
                                  ) : null}
                              </FormGroup>
                          </Col>
                          <Col md={3} mdOffset={1}>
                              <FormGroup className={`has-label ${emailState}`}>
                                  <label>Email Address *</label>
                                  <Input
                                      name="email"
                                      type="text"
                                      onChange={(e) => change(e, "email", "email",1)}
                                  />
                                  {emailState === "has-danger" ? (
                                      <label className="error">
                                          Please enter your email address.
                                      </label>
                                  ) : null}
                              </FormGroup>
                          </Col>
                      </Row>
                      ) : (
                      <div></div>
                      )}
                      {(registrationState.EventRequirePhone) ? (
                      <Row>
                          <Col md={5} mdOffset={1}>
                              <FormGroup className={`has-label ${phoneState}`}>
                                  <label>Your Phone *</label>
                                  <Input
                                      name="phone"
                                      type="text"
                                      maxLength={14}
                                      value={phone}
                                      onChange={(e) => change(e, "phone", "phone",1)}
                                  />
                                  {phoneState === "has-danger" ? (
                                      <label className="error">
                                          Please enter your phone number.
                                      </label>
                                  ) : null}
                              </FormGroup>
                          </Col>
                          {(registrationState.EventRequireDOB) ? (
                              <Col md={3} mdOffset={1}>
                                  <FormGroup className={`has-label ${dobState}`}>
                                      <label>Your Date of Birth *</label>
                                      <Input
                                          name="dob"
                                          type="text"
                                          maxLength={10}
                                          value={dob}
                                          onChange={(e) => change(e, "dob", "date",1)}
                                      />
                                      {dobState === "has-danger" ? (
                                          <label className="error">
                                              Please enter your Date of Birth.
                                          </label>
                                      ) : null}
                                  </FormGroup>
                              </Col>
                          ) : (
                              <div></div>
                          )}
                      </Row>
                      ) : (
                          <div></div>
                      )}
                      {(registrationState.EventRequireGender) ? (
                          <Row>
                              <Col md={5} mdOffset={1}>
                                  <FormGroup className={`has-label ${genderState}`}>
                                      <label>Your Gender *</label>
                                      <Input
                                          name="gender"
                                          type="select"
                                          id="gender"
                                          onChange={(e) => change(e, "gender", "length", 1)}
                                      >
                                          <option value="Male">Male</option>
                                          <option value="Female">Female</option>
                                      </Input>
                                      {genderState === "has-danger" ? (
                                          <label className="error">
                                              Please select your Gender.
                                          </label>
                                      ) : null}
                                  </FormGroup>
                              </Col>
                          </Row>
                          ) : (
                          <div></div>
                      )}
                  </CardBody>
              </Card>
          {(registrationState.EventIncludedQuestions.length !== 0) ? (
              <Card>
                  <CardHeader>Additional Questions:</CardHeader>
                  <CardBody>
                      <Row>
                          <Col md={5} mdOffset={1}>

                                  {(registrationState.EventIncludedQuestions.length !== 0) ? (
                                      registrationState.EventIncludedQuestions.map((item, index) => {
                                          const field = "question-" + index;
                                          const questionType = (item.Type || "String").trim();

                                          // Yes/No dropdown (handle variations: Yes/No, Yes, YesNo)
                                          if (questionType === "Yes/No" || questionType === "Yes" || questionType === "YesNo") {
                                              return (
                                                  <FormGroup key={field} className={`has-label ${questionsState}`}>
                                                      <label>{item.Title} *</label>
                                                      <Input
                                                          id={field}
                                                          type="select"
                                                          name={field}
                                                          data-idx={index}
                                                          value={registrationState.EventIncludedQuestions[index].Value || ""}
                                                          onChange={(e) => change(e, "questions", "questions", 1)}
                                                      >
                                                          <option value="">Select...</option>
                                                          <option value="Yes">Yes</option>
                                                          <option value="No">No</option>
                                                      </Input>
                                                      {questionsState === "has-danger" ? (
                                                          <label className="error">Answer ALL Questions!</label>
                                                      ) : null}
                                                  </FormGroup>
                                              );
                                          }

                                          // Checkbox
                                          if (questionType === "Checkbox") {
                                              return (
                                                  <FormGroup key={field} className={`has-label ${questionsState}`}>
                                                      <div className="form-check">
                                                          <Label check>
                                                              <Input
                                                                  id={field}
                                                                  type="checkbox"
                                                                  name={field}
                                                                  data-idx={index}
                                                                  checked={registrationState.EventIncludedQuestions[index].Value === "true" || registrationState.EventIncludedQuestions[index].Value === true}
                                                                  onChange={(e) => {
                                                                      const updatedQuestions = [...registrationState.EventIncludedQuestions];
                                                                      updatedQuestions[index].Value = e.target.checked.toString();
                                                                      setRegistrationState(registrationState => ({...registrationState, EventIncludedQuestions: updatedQuestions}));

                                                                      // Validate all questions after update
                                                                      const allAnswered = updatedQuestions.every(q => {
                                                                          const qType = (q.Type || "String").trim();
                                                                          if (qType === "Checkbox") {
                                                                              return q.Value === "true" || q.Value === true;
                                                                          }
                                                                          return q.Value && q.Value.trim() !== "";
                                                                      });

                                                                      if(allAnswered) {
                                                                          setquestionsState("has-success");
                                                                      } else {
                                                                          setquestionsState("has-danger");
                                                                      }
                                                                  }}
                                                              />
                                                              <span className="form-check-sign"></span>
                                                              {item.Title} *
                                                          </Label>
                                                      </div>
                                                      {questionsState === "has-danger" ? (
                                                          <label className="error">Answer ALL Questions!</label>
                                                      ) : null}
                                                  </FormGroup>
                                              );
                                          }

                                          // String (default - renders for "String" type and any unrecognized types)
                                          return (
                                              <FormGroup key={field} className={`has-label ${questionsState}`}>
                                                  <label>{item.Title} *</label>
                                                  <Input
                                                      id={field}
                                                      type="text"
                                                      name={field}
                                                      data-idx={index}
                                                      placeholder={item.PlaceHolder}
                                                      value={registrationState.EventIncludedQuestions[index].Value || ""}
                                                      onChange={(e) => change(e, "questions", "questions", 1)}
                                                  />
                                                  {questionsState === "has-danger" ? (
                                                      <label className="error">Answer ALL Questions!</label>
                                                  ) : null}
                                              </FormGroup>
                                          );
                                      }))
                                      :
                                      (
                                          <div></div>
                                      )}

                          </Col>
                      </Row>
                  </CardBody>
              </Card>
          )
          :
          (
              <div></div>
          )}
      </>
  );
});

export default Step2;
